export default __webpack_public_path__ + "static/media/SnapFood-logo.fb9318b3.png";